import { render, staticRenderFns } from "./CostSection.vue?vue&type=template&id=213a966a&"
import script from "./CostSection.vue?vue&type=script&lang=js&"
export * from "./CostSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports